import React, { useState } from "react";
import { Polygon, InfoWindow } from "@react-google-maps/api";
import { Button,Tooltip, Progress } from "antd";
import ApprovalDashboard from "./ApprovalDashboard";
import { AlignLeft, AlignRight, Zap, Droplets, Bus, Trash2, ParkingCircle, Lightbulb, Sparkles, Factory, MoreHorizontal } from "lucide-react";

const ApprovalRatingMap = ({
  mapRef,
  polygonPaths,
  approvalData,
  approvalResponseData,
  setPolygonPaths,
  showApprovalRating,
}) => {
    const [selectedPolygon, setSelectedPolygon] = useState(null);
    const [showDashboard, setShowDashboard] = useState(true);

    // Mapping icons to issues
const issueIcons = {
  "Electricity": <Zap size={40} className="text-yellow-600" />,
  "Drinking water": <Droplets size={40} className="text-blue-500" />,
  "Roads or transport": <Bus size={40} className="text-green-600" />,
  "Garbage collection or waste management": <Trash2 size={40} className="text-red-500" />,
  "Parking Space": <ParkingCircle size={40} className="text-purple-600" />,
  "Maintenance of streetlights, public toilets and footpaths": <Lightbulb size={40} className="text-orange-500" />,
  "Cleanliness and hygiene": <Sparkles size={40} className="text-pink-500" />,
  "Pollution": <Factory size={40} className="text-gray-600" />,
  "Others": <MoreHorizontal size={40} className="text-black" />,
};

const issuesData = {
  "Bangalore South": {
    "Electricity": 8.6,
    "Drinking water": 15.3,
    "Roads or transport": 22.7,
    "Garbage collection or waste management": 10.4,
    "Parking Space": 4.9,
    "Maintenance of streetlights, public toilets and footpaths": 11.7,
    "Cleanliness and hygiene": 11.0,
    "Pollution": 3.1,
    "Others": 12.3,
  },
  "Bommanahalli": {
    "Electricity": 11.1,
    "Drinking water": 14.7,
    "Roads or transport": 18.2,
    "Garbage collection or waste management": 13.6,
    "Parking Space": 5.1,
    "Maintenance of streetlights, public toilets and footpaths": 12.1,
    "Cleanliness and hygiene": 10.6,
    "Pollution": 2.5,
    "Others": 12.1,
  },
  "Byatarayanapura": {
    Electricity: 10.3,
    "Drinking water": 9.6,
    "Roads or transport": 24.4,
    "Garbage collection or waste management": 19.2,
    "Parking Space": 5.1,
    "Maintenance of streetlights, public toilets and footpaths": 9.6,
    "Cleanliness and hygiene": 10.9,
    Pollution: 4.5,
    Others: 6.4,
  },
  "C V Raman Nagar": {
    Electricity: 8.1,
    "Drinking water": 15.0,
    "Roads or transport": 20.5,
    "Garbage collection or waste management": 16.9,
    "Parking Space": 8.1,
    "Maintenance of streetlights, public toilets and footpaths": 9.4,
    "Cleanliness and hygiene": 9.4,
    Pollution: 3.8,
    Others: 8.8,
  },
  "Govindaraja Nagar": {
    Electricity: 10.6,
    "Drinking water": 13.8,
    "Roads or transport": 23.0,
    "Garbage collection or waste management": 16.1,
    "Parking Space": 3.7,
    "Maintenance of streetlights, public toilets and footpaths": 12.0,
    "Cleanliness and hygiene": 8.8,
    Pollution: 2.8,
    Others: 9.2,
  },
  "Krishnarajapuram": {
    Electricity: 10.2,
    "Drinking water": 11.2,
    "Roads or transport": 13.3,
    "Garbage collection or waste management": 21.3,
    "Parking Space": 8.6,
    "Maintenance of streetlights, public toilets and footpaths": 8.6,
    "Cleanliness and hygiene": 15.5,
    Pollution: 2.7,
    Others: 8.6,
  },
  "Mahadevapura": {
    Electricity: 8.7,
    "Drinking water": 12.6,
    "Roads or transport": 16.9,
    "Garbage collection or waste management": 19.7,
    "Parking Space": 6.6,
    "Maintenance of streetlights, public toilets and footpaths": 10.9,
    "Cleanliness and hygiene": 10.9,
    Pollution: 4.4,
    Others: 9.3,
  },
  "Malleshwaram": {
    Electricity: 7.9,
    "Drinking water": 10.6,
    "Roads or transport": 19.2,
    "Garbage collection or waste management": 15.2,
    "Parking Space": 9.3,
    "Maintenance of streetlights, public toilets and footpaths": 11.9,
    "Cleanliness and hygiene": 15.9,
    Pollution: 4.0,
    Others: 6.0,
  },
  "Pulakeshinagar": {
    Electricity: 5.4,
    "Drinking water": 11.7,
    "Roads or transport": 19.0,
    "Garbage collection or waste management": 17.0,
    "Parking Space": 4.8,
    "Maintenance of streetlights, public toilets and footpaths": 12.9,
    "Cleanliness and hygiene": 15.6,
    Pollution: 5.4,
    Others: 8.2,
  },
   "Rajarajeswarinagar": {
    Electricity: 9.1,
    "Drinking water": 12.2,
    "Roads or transport": 21.3,
    "Garbage collection or waste management": 18.8,
    "Parking Space": 4.1,
    "Maintenance of streetlights, public toilets and footpaths": 9.1,
    "Cleanliness and hygiene": 12.7,
    Pollution: 2.0,
    Others: 10.7,
  },
  "Shanti Nagar": {
    Electricity: 9.9,
    "Drinking water": 12.4,
    "Roads or transport": 23.0,
    "Garbage collection or waste management": 11.8,
    "Parking Space": 5.6,
    "Maintenance of streetlights, public toilets and footpaths": 11.2,
    "Cleanliness and hygiene": 11.8,
    Pollution: 3.1,
    Others: 11.2,
  },
  "Shivajinagar": {
    Electricity: 6.3,
    "Drinking water": 14.5,
    "Roads or transport": 18.9,
    "Garbage collection or waste management": 23.9,
    "Parking Space": 4.4,
    "Maintenance of streetlights, public toilets and footpaths": 11.9,
    "Cleanliness and hygiene": 7.5,
    Pollution: 2.5,
    Others: 10.1,
  },
  "Yelahanka": {
    Electricity: 10.0,
    "Drinking water": 11.1,
    "Roads or transport": 25.5,
    "Garbage collection or waste management": 23.3,
    "Parking Space": 5.6,
    "Maintenance of streetlights, public toilets and footpaths": 10.0,
    "Cleanliness and hygiene": 5.6,
    Pollution: 3.3,
    Others: 5.6,
  }
};

  // Enhanced sample data for comprehensive approval metrics
  const comprehensiveApprovalData = {
    overall: {
      rating: 64,
      totalSample: 2730,
      state: "Karnataka",
      district: "Bangalore Urban",
      areasCount: 13
    },
    ageWise: {
        totalSample:890,
        rating:78
    },
    genderWise: {
        totalSample:780,
        rating:40
    },
  };

  const getApprovalColor = (approval) => {
    if (approval >= 80) return "#2E7D32";   
    if (approval >= 60) return "#8BC34A";  
    if (approval >= 40) return "#FFD54F";   
    if (approval >= 20) return "#FF8C00";   
    return "#B2182B";                       
  };

  const getApprovalTextColor = (approval) => {
    if (approval >= 80) return "text-green-700";
    if (approval >= 60) return "text-green-600";
    if (approval >= 40) return "text-yellow-600";
    if (approval >= 20) return "text-orange-600";
    return "text-red-600";
  };

  const handlePolygonClick = (polygon) => {
    setSelectedPolygon(polygon);
    const bounds = new window.google.maps.LatLngBounds();
    polygon.coordinate?.forEach((point) => bounds.extend(point));
    mapRef.current?.fitBounds(bounds);
    mapRef.current?.setZoom(mapRef.current.getZoom() - 0.5);
  };
  const handleBackClick = () => {
    setSelectedPolygon(null);
    const bounds = new window.google.maps.LatLngBounds();
    polygonPaths?.forEach((poly) =>
      poly.coordinate?.forEach((point) => bounds.extend(point))
    );
    mapRef.current?.fitBounds(bounds);
  };

  const renderPolygons = () => {
    if (!polygonPaths || !Array.isArray(polygonPaths)) return null;

    return polygonPaths.map((polygon, index) => {
      const bounds = new window.google.maps.LatLngBounds();
      polygon?.coordinate?.forEach((point) => bounds.extend(point));

      const approvalEntry =
        approvalData.find(
          (entry) => entry.area?.toLowerCase() === polygon.name?.toLowerCase()
        ) || {};

      const approvalPercent = approvalEntry?.approval ?? 0;
      const polyColor = getApprovalColor(approvalPercent);
      const isSelected = selectedPolygon?.name === polygon.name;

      return (
        <React.Fragment key={index}>
          <Polygon
            paths={polygon.coordinate}
            onClick={() => handlePolygonClick(polygon)}
            options={{
              strokeColor: isSelected ? "#0D47A1" : polyColor,
              fillColor: isSelected ? "#0D47A1" : polyColor,
              fillOpacity: isSelected ? 0.6 : 0.45,
              strokeOpacity: 0.9,
              strokeWeight: 2,
              zIndex:999
            }}
          />
          {isSelected && (
            <InfoWindow
              position={bounds.getCenter()}
              onCloseClick={handleBackClick}
            >
              <div className="bg-white/20 backdrop-blur-[30px] border border-white/40 p-3 rounded-lg">
                <div className="text-lg font-bold text-[#3bbee8] mb-2">
                  {selectedPolygon.name}
                </div>
                <div className="text-sm font-semibold text-black">
                  Sample: {approvalEntry?.sample ?? "N/A"}
                </div>
                <div className="text-sm font-semibold text-black">
                  Approval Rating: {approvalPercent}%
                </div>
                <div className="mt-2 flex justify-center">
                  <Button onClick={handleBackClick} size="small">
                    Back
                  </Button>
                </div>
              </div>
            </InfoWindow>
          )}
        </React.Fragment>
      );
    });
  };

  return (
    <>
      {showApprovalRating && renderPolygons()}
      {/* Dashboard Toggle Button */}
      {!selectedPolygon && <div className="absolute top-[50%] right-4 z-[20]">
        <Tooltip title={showDashboard ? "Hide" : "Show Dashboard"}>
            <Button
                type="default"
                className="bg-white text-black border-none rounded-xl shadow-lg transition-all duration-300 ease-in-out hover:scale-110 flex items-center justify-center w-12 h-12"
                onClick={() => setShowDashboard(!showDashboard)}
                icon={showDashboard ? <AlignLeft size={25} /> : <AlignRight size={25} />}
            />
        </Tooltip>
        
      </div>}
      {/* Enhanced Approval Rating Dashboard */}
      <div className="absolute top-4 left-4 bg-glass backdrop-blur-[40px] border border-white/40 rounded-3xl shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] max-w-lg">
        <div className="p-4">
          {/* Header Section */}
          <div className="text-center mb-4">
            <div className="text-lg font-bold text-[#004877] mb-1">
              Overall Approval Rating
            </div>
            <div className={`text-2xl font-extrabold mb-1 ${getApprovalTextColor(comprehensiveApprovalData.overall.rating)}`}>
              {comprehensiveApprovalData.overall.rating}%
            </div>
            <div className="text-xs font-semibold heading-white mb-1">
              {comprehensiveApprovalData.overall.state} • {comprehensiveApprovalData.overall.district}
            </div>
            <div className="text-xs subheading">
              Total Sample: {comprehensiveApprovalData.overall.totalSample.toLocaleString()} | Areas Covered: {comprehensiveApprovalData.overall.areasCount}
            </div>
          </div>

         <div className="grid grid-row-1 lg:grid-row-2 gap-3">
  {/* Age-wise Summary */}
  <div className="bg-white/20 backdrop-blur-[30px] rounded-xl p-2 text-center">
    <div className="text-sm font-bold text-[#004877] mb-2">
      Age-wise Approval
    </div>
    <div className="flex gap-3 justify-center items-start">
        <div>
            <div className="text-lg font-extrabold text-black">
              {comprehensiveApprovalData.ageWise.totalSample}
            </div>
            <div className="text-xs subheading mb-1">Total Sample</div>
        </div>
        <div>
            <div className={`text-xl font-bold ${getApprovalTextColor(
                Math.round(
                    comprehensiveApprovalData.ageWise.rating
                )
            )}`}>
                {Math.round(
                    comprehensiveApprovalData.ageWise.rating
                )}%
            </div>
            <div className="text-xs subheading">Overall Approval</div>
        </div>
    </div>
  </div>

  {/* Gender-wise Summary */}
  <div className="bg-white/20 backdrop-blur-[30px] rounded-xl p-2 text-center">
    <div className="text-sm font-bold text-[#004877] mb-2">
      Gender-wise Approval
    </div>
    <div className="flex gap-3 justify-center items-start">
        <div>
            <div className="text-lg font-extrabold text-black">
               {comprehensiveApprovalData.genderWise.totalSample}
            </div>
            <div className="text-xs subheading mb-1">Total Sample</div>
        </div>
        <div>
            <div className={`text-xl font-bold ${getApprovalTextColor(
                Math.round(
                    comprehensiveApprovalData.genderWise.rating
                )
            )}`}>
              {Math.round(
                    comprehensiveApprovalData.genderWise.rating
                )}%
            </div>
            <div className="text-xs subheading">Overall Approval</div>
        </div>
    </div>
  </div>
</div>
        </div>
      </div>

      {selectedPolygon ? (
  <div className="absolute top-15 right-4 bg-glass backdrop-blur-[40px] border border-white/40 rounded-3xl shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] p-4 w-[25%]">
    {(() => {
      const issues = issuesData[selectedPolygon.name] || {};
      const sortedIssues = Object.entries(issues).sort((a,b) => b[1]-a[1]);
      const [topIssue, topValue] = sortedIssues[0] || [];

      return (
        <>
          <div className="text-center mb-4">
            <div className="text-lg font-bold text-[#004877]">
              {selectedPolygon.name} - Key Concern
            </div>
            <div className="text-xl font-extrabold text-red-600 flex items-center justify-center gap-2">
              {issueIcons[topIssue]} {topIssue} ({topValue}%)
            </div>
          </div>
          <div className="space-y-2">
            {sortedIssues.map(([issue, value]) => (
              <div key={issue} className="flex items-center gap-2">
                {issueIcons[issue]}
                <span className="w-80 text-sm font-semibold text-black">{issue}</span>
                <Progress percent={value} showInfo />
              </div>
            ))}
          </div>
          <div className="mt-4 flex justify-center">
            <Button onClick={handleBackClick} size="small">Back</Button>
          </div>
        </>
      );
    })()}
  </div>
) : (
  showDashboard && (
    <ApprovalDashboard
      approvalData={approvalData}
      approvalResponseData={approvalResponseData}
      selectedPolygon={selectedPolygon}
      setSelectedPolygon={setSelectedPolygon}
    />
  )
)}

      {/* Legend */}
      <div className="absolute bottom-4 left-4 bg-white/20 backdrop-blur-[30px] border border-white/40 rounded-2xl p-4 shadow-lg text-sm max-w-sm">
        <div className="font-semibold mb-3 text-center text-lg text-[#004877]">
          Approval Rating Legend
        </div>

        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <span className="w-4 h-4 rounded" style={{ backgroundColor: "#2E7D32" }}></span>
            <div className="flex flex-col">
              <div className="font-semibold text-black text-start">80–100% – Excellent</div>
              <div className="text-gray-700 text-start">Strong mandate / highly positive</div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <span className="w-4 h-4 rounded" style={{ backgroundColor: "#8BC34A" }}></span>
            <div className="flex flex-col">
              <div className="font-semibold text-black text-start">60–79% – Good</div>
              <div className="text-gray-700 text-start">Generally favorable</div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <span className="w-4 h-4 rounded" style={{ backgroundColor: "#FFD54F" }}></span>
            <div className="flex flex-col">
              <div className="font-semibold text-black text-start">40–59% – Mixed</div>
              <div className="text-gray-700 text-start" >Split opinion — needs attention</div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <span className="w-4 h-4 rounded" style={{ backgroundColor: "#FF8C00" }}></span>
            <div className="flex flex-col">
              <div className="font-semibold text-black text-start">20–39% – Poor</div>
              <div className="text-gray-700 text-start">Weak support — remedial action needed</div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <span className="w-4 h-4 rounded" style={{ backgroundColor: "#B2182B" }}></span>
            <div className="flex flex-col">
              <div className="font-semibold text-black text-start">0–19% – Critical</div>
              <div className="text-gray-700 text-start">Very low approval — urgent action</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApprovalRatingMap;